<template>
  <div>
    <div class="row" id="addPriceListform">
      <div class="col-md-4 mt-2 col-12">
        <small class="">مربوط به مشتری</small>
        <SearchableCombo :edit="false" :grp="0" :code="null" :rownumintable="1" @ResultCombo="GetResulTblCustomerId"
          :action="'TblCrmCombo/GetCostomerProduct'" :method="'POST'" :idinput="'TblProductsId'"
          :keyItem="'TblProductsId'" :disabled="false" :ClassProps="'required'">
        </SearchableCombo>
      </div>

      <div class="col-md-4 col-12 mt-2" dir="rtl">
        <small id="LblTblCustomerProduct">انتخاب لیست قیمت</small>
        <treeselect name="CustomerContract" :multiple="true" :clearable="false" :searchable="true" :disabled="false"
          :open-on-click="true" :open-on-focus="false" :clear-on-select="true" :close-on-select="false"
          :always-open="false" :append-to-body="false" :options="options" v-model="value" :normalizer="normalizer"
          @select="ItemSelected" @deselect="ItemDeselect">
        </treeselect>
      </div>

      <div class="col-md-4 col-12" style="margin-top: 27px">
        <button class="btn btn-success col" @click="submit()">ثبت</button>
      </div>
    </div>

    <table class="table table-bordered mt-2">
      <thead>
        <tr>
          <th>نام محصول</th>
          <th>قیمت</th>
          <th>توضیحات</th>
        </tr>
      </thead>

      <tbody v-if="render">
        <tr v-for="(item, index) in masterItems" :key="index" :class="item.main ? ['bg-info'] : ['']">
          <td>
            <input type="text" v-model="item.name" class="form-control required" />
          </td>

          <td class="text-center">
            <input
              type="text"
              v-model="item.modelPrice"
              class="form-control required InputText 3ragham"
              dir="ltr"
              @keyup="item.modelPrice = $PutCommatoInput_New($event);"
              @keypress="$ValidNumber($event, 15)"
            />
          </td>

          <td>
            <input type="text" v-model="item.des" class="form-control required" />
          </td>
        </tr>

      </tbody>
    </table>
    <div class="row">
      <div class="col-12">
        <textarea v-model="newRow.PrintDes"
        class="form-control" style="resize: none;height: 100px;"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import datePicker from "vue-persian-datetime-picker";
import Treeselect from "@riophae/vue-treeselect";

export default {
  components: { SearchableCombo, datePicker, Treeselect },

  data() {
    return {
      newRow: {},
      options: [],
      value: [],
      normalizer(node) {
        return {
          id: node.tblPriceListMasterId,
          label: node.masterName,
        };
      },
      masterItems: [],
      render: true,
      mainPrice: 0,
    };
  },

  mounted() {
    this.getMasterPriceTree();
    this.setPrintDes()
  },

  methods: {
    submit() {
      if (this.$ValidForm("addPriceListform")) {
        this.newRow.TblCustomerPriceListDetail = [];

        let mainCount = 0;
        this.masterItems.forEach((el) => {
          if (el.main) {
            mainCount++;
          }
          this.newRow.TblCustomerPriceListDetail.push({
            TblPriceListMasterId: el.tblPriceListMasterId,
            TblProductsId: el.productId,
            NameProduct: el.name,
            TotallAmount: el.modelPrice,
            Des: el.des,
          });
        });

        if (mainCount <= 0) {
          this.$mySweetDefaultTost(
            "",
            "لیست قیمت آیتم اصلی ندارد",
            "info",
            3000
          );
          return;
        }
        if (mainCount > 1) {
          this.$mySweetDefaultTost(
            "",
            "لیست قیمت بیش از یک آیتم اصلی دارد",
            "info",
            3000
          );
          return;
        }

        let DataaxiosDepUser = {
          Action: "PriceList/AddCustomerPriceListDetail",
          Method: "POST",
          ArryfildValue: this.newRow,
        };

        this.$PostData(DataaxiosDepUser)
          .then((res) => {
            if (res.isSuccess) {
              this.$emit("addRowResult", res.isSuccess);
              this.$mySweetDefaultTost(
                "عملیات موفق",
                res.message,
                "success",
                2000
              );
            } else {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                res.message,
                "error",
                2000
              );
            }
          })
          .catch((err) => {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطایی رخ داد",
              "error",
              2000
            );
            console.error(err);
          });
      }
    },

    getMasterPriceTree() {
      let DataaxiosDepUser = {
        Action: "TblCrmCombo/GetPriceListMaster",
        Method: "POST",
        ArryfildValue: null,
      };

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.options = res;
          this.options.forEach((el) => {
            el.modelPrice = el.price;
          });
        })
        .catch((err) => {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "خطایی رخ داد",
            "error",
            2000
          );
          console.error(err);
        });
    },

    ItemDeselect(node) {
      let record = this.masterItems.find(
        (x) => x.tblPriceListMasterId == node.tblPriceListMasterId
      );
      let index = this.masterItems.indexOf(record);
      this.masterItems.splice(index, 1);
    },

    ItemSelected(node) {
      let checkResult = this.check(node);
      if (checkResult) {
        node.des = node.name
        this.masterItems.push(node);
        this.masterItems.forEach((element) => {
          if(element.modelPrice != null){
            element.modelPrice = this.$Comma3ragham(element.modelPrice);
          }else{
            element.modelPrice = ''
          }
        });

      } else {
        setTimeout(() => {
          let record = this.value.find((x) => x == node.tblPriceListMasterId);
          let index = this.value.indexOf(record);
          this.value.splice(index, 1);
        }, 300);
      }
    },

    check(node) {
      let mainCount = node.main == true ? 1 : 0;
      let haveMain = node.main;

      this.masterItems.forEach((el) => {
        if (el.main) {
          mainCount++;
          haveMain = true;
        }
      });

      if (mainCount > 1) {
        this.$mySweetDefaultTost(
          "",
          "تعداد آیتم های قیمت اصلی نمیتواند بیشتر از یکی باشد",
          "info",
          3000
        );
        return false;
      }

      if (node.main) {
        this.mainPrice = node.price;
      }

      if (haveMain & !node.main) {
        if ((node.func != null) & (node.func != "")) {
          node.func = node.func.replace("%", "");
          node.modelPrice = (this.mainPrice * node.func) / 100;
          if (node.modelPrice > node.maxPrice & node.maxPrice != null) {
            node.modelPrice = node.maxPrice;
          }
          if (node.modelPrice < node.minPrice & node.minPrice != null) {
            node.modelPrice = node.minPrice;
          }
        } else if (node.fixPrice == false) {
          this.$mySweetDefaultTost(
            "",
            "آیتم انخابی نه قیمت ثابت است و نه فرمول دارد",
            "info",
            3000
          );
          return false;
        }
      } else {
        this.masterItems.forEach((el) => {
          if (!el.main) {
            if ((el.func != null) & (el.func != "")) {
              el.func = el.func.replace("%", "");
              el.modelPrice = (this.mainPrice * el.func) / 100;
              if (el.modelPrice > el.maxPrice & el.maxPrice != null) {
                el.modelPrice = el.maxPrice;
              }
              if (el.modelPrice < el.minPrice & el.minPrice != null) {
                el.modelPrice = el.minPrice;
              }
            }
          }
        });
      }

      if (haveMain == false) {
        this.options.forEach((el) => {
          el.modelPrice = el.price;
        });
      }
      return true;
    },

    GetResulTblCustomerId(data) {
      if (data.id != null) {
        this.newRow.TblCustomerId = data.id;
      }
    },

    setPrintDes(){
      this.newRow.PrintDes = ''
      this.newRow.PrintDes += "● شایان ذکر است پرداخت هرگونه مالیات و عوارض بر ارزش افزوده بر عهده خریدار می باشد."
      this.newRow.PrintDes += '\n'
      this.newRow.PrintDes += '● موارد ستاره دار ( *) به صورت اشتراك یکساله ارائه شده و پس از یکسال نیاز به تمدید مجدد دارد.'
      this.newRow.PrintDes += '\n'
      this.newRow.PrintDes += '● با انتخاب همزمان سامانه همپا و نتپا ، سامانه USSD به صورت رایگان هدیه خواهد شد.'
      this.newRow.PrintDes += '\n'
      this.newRow.PrintDes += '● 10 %تخفیف با پرداخت نقدي کل مبلغ فاکتور'
    }
  },
};
</script>

<style scoped>
.D_Products {
  background: var(--sidebar-action-bg);
  border-radius: 5px;
}

tr {
  color: var(--sidebar-color-item) !important;
}

table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}

td {
  border-color: var(--table-border-color) !important;
}

th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}

thead {
  border-color: var(--table-border-color) !important;
}

tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}

#header-Selected {
  width: 5% !important;
}

.borderd span:not(.fas):not(.fad) {
  color: rgb(253, 93, 8) !important;
}

td input {
  font-size: 10px !important;
}

td {
  font-size: 10px;
}
</style>
